module.exports = __webpack_public_path__ + "static/bbq-sm-9ead6cbd4fe79d6f96bf76569c5185d1.jpg";